// import Vue from 'vue'
import Axios from 'axios'
// import {WechatPlugin} from 'vux'
// Vue.use(WechatPlugin) //  微信
import { domainNameConstant } from './domainnameconstant';
/**
 * 微信分享
 * @param {微信签名所需对象} sd
 * @param {分享所需字段} sharobj
 * @param {分享所需链接地址} href
 */
export const wxInit = (sharobj) => {
  // const wx = Vue.wechat
  const wx = window.wx
  Axios.get(`//${domainNameConstant}/ucenter/api/wx/jsapi_signature`).then(res => {
    if (res.data.code === 200) {
      let sd = res.data.data
      window.wx.config({
        debug: false,
        appId: sd.appId,
        timestamp: sd.timestamp,
        nonceStr: sd.nonceStr,
        signature: sd.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
      })
      wx.ready(function () {
        wx.onMenuShareTimeline({
          title: sharobj.shareTitle, // 分享标题
          desc: sharobj.shareDes, // 分享描述
          // link: window.location.origin + '/app/dmstore?store_id=' + _this.storeid, // 分享链接
          link: sharobj.shareUrl, // 分享链接
          imgUrl: sharobj.shareImgUrl, // 分享图标
          success: function () {
            // alert("分享到朋友圈成功")
          },
          cancel: function () {
            // alert("分享失败,您取消了分享!")
          }
        })
        wx.onMenuShareAppMessage({
          title: sharobj.shareTitle, // 分享标题
          desc: sharobj.shareDes, // 分享描述
          link: sharobj.shareUrl, // 分享链接
          imgUrl: sharobj.shareImgUrl, // 分享图标
          success: function () {
            // alert("成功分享给朋友")
          },
          cancel: function () {
            // alert("分享失败,您取消了分享!")
          }
        })
        wx.onMenuShareQQ({
          title: sharobj.shareTitle, // 分享标题
          desc: sharobj.shareDes, // 分享描述
          link: sharobj.shareUrl, // 分享链接
          imgUrl: sharobj.shareImgUrl, // 分享图标
          success: function () {},
          cancel: function () {}
        })
        wx.onMenuShareWeibo({
          title: sharobj.shareTitle, // 分享标题
          desc: sharobj.shareDes, // 分享描述
          link: sharobj.shareUrl, // 分享链接
          imgUrl: sharobj.shareImgUrl, // 分享图标
          success: function () {
            // alert("成功分享给朋友")
          },
          cancel: function () {
            // alert("分享失败,您取消了分享!")
          }
        })
        wx.onMenuShareQZone({
          title: sharobj.shareTitle, // 分享标题
          desc: sharobj.shareDes, // 分享描述
          link: sharobj.shareUrl, // 分享链接
          imgUrl: sharobj.shareImgUrl, // 分享图标
          success: function () {
            // alert("成功分享给朋友")
          },
          cancel: function () {
            // alert("分享失败,您取消了分享!")
          }
        })
      })
      wx.error(function (error) {
        console.log('wx error',error)
      })
    }
  })
}
